module.exports = __webpack_public_path__ + "img/greenline-logo.b0e0ac5.png";